"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useLanguage } from "../../../hooks/useLanguage.js";
import { useLocaleText } from "../../../hooks/useLocaleText.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { rem, Box } from "@mantine/core";
import { forwardRef, useState } from "react";
import BreakingBanner from "./parts/BreakingBanner/BreakingBanner.js";
import FullscreenNav from "./parts/FullscreenNav/FullscreenNav.js";
import GlobalNavbar from "./parts/GlobalNavbar/GlobalNavbar.js";
import LocalNavbar from "./parts/LocalNavbar/LocalNavbar.js";
import '../../../assets/Header.css';const header = "_header_1uf0a_2";
const headerPlaceholder = "_headerPlaceholder_1uf0a_14";
const HeaderStyles = {
  header,
  headerPlaceholder
};
const _Header = forwardRef((props, ref) => {
  const {
    localLinks,
    search,
    showRegister,
    showUserLogin = true,
    globalLinks = [
      {
        href: "https://ida.dk",
        text: "IDA.DK"
      },
      {
        href: "https://idaforsikring.dk",
        text: "IDA Forsikring"
      },
      {
        href: "https://studerende.ida.dk/",
        text: "IDA Studerende"
      }
    ],
    languages,
    logo,
    user,
    actionLink,
    breakingBannerContent,
    selectedSite = "IDA.DK",
    languagesPolymorphicProps,
    variant,
    localLinksLoading,
    className,
    mod,
    ...rest
  } = props;
  const [openFullscreen, setOpenFullscreen] = useState(false);
  const texts = useLocaleText();
  const { language } = useLanguage();
  const registerLink = {
    href: `https://indmeld.ida.dk/${language !== "da" ? language : ""}`,
    text: texts.register,
    target: "_self"
  };
  const styleVariables = {
    "--passed-breaking-banner-height-base": rem("70px"),
    "--passed-breaking-banner-height-md": rem("35px"),
    "--passed-global-navbar-height": rem("56px"),
    "--passed-local-navbar-height-base": rem("70px"),
    "--passed-local-navbar-height-lg": rem("64px")
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        className: `${HeaderStyles.headerPlaceholder}`,
        "data-with-breaking-banner": Boolean(breakingBannerContent),
        style: styleVariables
      }
    ),
    /* @__PURE__ */ jsxs(
      Box,
      {
        ...rest,
        component: "header",
        className: `${HeaderStyles.header} ${className}`,
        id: "header",
        ref,
        mod: { "with-breaking-banner": Boolean(breakingBannerContent), ...mod },
        children: [
          breakingBannerContent && /* @__PURE__ */ jsx(
            BreakingBanner,
            {
              content: breakingBannerContent,
              "aria-label": "Breaking news banner",
              style: styleVariables
            }
          ),
          /* @__PURE__ */ jsx(
            GlobalNavbar,
            {
              links: globalLinks,
              languages,
              register: showRegister ? registerLink : void 0,
              "aria-label": "Global menu",
              selectedSite,
              languagesPolymorphicProps,
              className: HeaderStyles.globalNavbar,
              style: styleVariables
            }
          ),
          /* @__PURE__ */ jsx(
            LocalNavbar,
            {
              isMenuOpen: openFullscreen,
              openMenu: setOpenFullscreen,
              links: localLinks,
              logo,
              search,
              user,
              register: showRegister ? registerLink : void 0,
              actionLink,
              "aria-label": "Lokal menu",
              transparent: variant === "transparent",
              isLoading: localLinksLoading,
              style: styleVariables,
              showUserLogin
            }
          ),
          /* @__PURE__ */ jsx(
            FullscreenNav,
            {
              hiddenFrom: "md",
              links: localLinks,
              globalLinks,
              user,
              actionLink,
              showUserLogin,
              languages,
              languagesPolymorphicProps,
              isLoading: localLinksLoading,
              isOpen: openFullscreen,
              openMenu: setOpenFullscreen,
              style: styleVariables
            }
          )
        ]
      }
    )
  ] });
});
_Header.displayName = "Header";
const Header = sharedHandler(_Header);
Header.displayName = _Header.displayName;
export {
  HeaderStyles as H,
  Header as default
};
